import { render, staticRenderFns } from "./VTaskSubtaskControl.vue?vue&type=template&id=5aa52073&scoped=true&"
import script from "./VTaskSubtaskControl.vue?vue&type=script&lang=ts&"
export * from "./VTaskSubtaskControl.vue?vue&type=script&lang=ts&"
import style0 from "./VTaskSubtaskControl.vue?vue&type=style&index=0&id=5aa52073&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa52073",
  null
  
)

export default component.exports